import React from "react";
import { fetchAppCheckout } from "actions/app";
import { createMerchantAccountShippingRates } from "actions/shippingRate";
import { fetchMerchantAccountProductsPrices } from "actions/merchantAccount";
import { CREATE_SHIPPING_RATES_SCHEMA } from "constants/validation";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Formik } from "formik";
import Padder from "components/Padder";
import {
  prepareCreateShippingRateInitialValues,
  prepareCreateShippingRates,
  validateShippingRateSchema
} from "utils/shippingRate";
import ShippingRateNewList from "./ShippingRateNewList";
import {
  ensureAppCheckout,
  ensureProductsPrices,
  useScrollTopOnMount
} from "utils/hooks";
import { useCtxReferences } from "utils/selectors";
import { usePrevPathFragment } from "utils/hooks/hub";
import { useRouter } from "next/router";
import InfoNotice from "components/InfoNotice";
import { THEMES } from "utils/constants/ui";

const ShippingRateCreate = ({ actions, header, afterCreate }) => {
  useScrollTopOnMount();
  const backPath = usePrevPathFragment();

  ensureProductsPrices({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices
  });
  ensureAppCheckout({
    fetchAppCheckout: actions.fetchAppCheckout
  });
  const {
    resourceID,
    resourceUUID,
    resource,
    merchantAccountUUID
  } = useCtxReferences();

  const { replace } = useRouter();

  const goShow = (id) => {
    replace(`${backPath}/${id}`);
  };

  const submitForm = (formValues, formikActions) => {
    const data = prepareCreateShippingRates(formValues.shippingRates);

    actions.createMerchantAccountShippingRates(
      {
        resourceID,
        resourceUUID,
        resource,
        uuid: merchantAccountUUID,
        data
      },
      (err, responseData) => {
        /**
         * 1. Turn off loader
         */
        formikActions.setSubmitting(false);
        /**
         * 2. Show errors or reset form
         */
        if (err) {
          formikActions.setErrors(err);
        } else {
          formikActions.resetForm({ values: formValues });
        }

        /**
         * 3a. Call afterCreate handler or
         * 3b. Perform default conditional navigation
         */
        if (afterCreate) {
          afterCreate(err, responseData);
        } else {
          /**
           * If creating multiple - redirect to index
           * If creating single - redirect to show
           */
          if (
            responseData &&
            responseData.shippingRates &&
            responseData.shippingRates.length
          ) {
            responseData.shippingRates.length > 1
              ? replace(backPath)
              : goShow(responseData.shippingRates[0].id);
          } else {
            replace(backPath);
          }
        }
      }
    );
  };
  const initialValues = prepareCreateShippingRateInitialValues();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitForm}
      validate={validateShippingRateSchema}
    >
      {({ status }) => {
        return (
          <div className="w-100 db">
            {!!status && (
              <div className="pb3">
                <InfoNotice copy={status} theme={THEMES.ERROR} />
              </div>
            )}
            <ShippingRateNewList name="shippingRates" header={header} />
            <Padder theme="visible" />
          </div>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createMerchantAccountShippingRates,
      fetchMerchantAccountProductsPrices,
      fetchAppCheckout
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ShippingRateCreate);
